import axios from 'axios';
import Config from '../common/config/config';

 
// 
const api = axios.create({
  baseURL:Config.API_URL, // Replace with your API base URL
});
const apiLogin = axios.create({
  baseURL:"http://CHI-RV-TT1:8013", // Replace with your LDap corp url
});
export const getCorpDetails = async (payload) => {
  // console.log('get payload: ', payload)
  try {
    const response = await apiLogin.post('/api/LDAP/LoginLDAPWithCorpName', payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching first table data:', error);
    
  }
};
export const logoutAcitivityInfo = async (payload) => {

  // console.log(' end detail',payload);
  // try {
  //   // const response = await apiLogin.get('/api/LDAP/LoginLDAPWithCorpName', payload);
  //   // return response.data;
  // } catch (error) {
  //   console.error('Error fetching first table data:', error);
  //   throw error;
  // }
};
export const getFirstTableData = async () => {
  try {
    const response = await api.get('/get_first_table');
    return response.data;
  } catch (error) {
    console.error('Error fetching first table data:', error);
    
  }
};
export const secondTableDataApi = async (payload) => {
  try {
    const response = await api.post('/get_second_table',payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching first table data:', error);
    
  }
};
export const onChangeTableDataApi = async (payload) => {
  try {
    const response = await api.post('/get_onchange_values',payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching first table data:', error);
    
  }
};
export const lookTableDataApi = async (payload) => {
  try {
    const response = await api.post('/get_lookup_table',payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching first table data:', error);
    // Snackbars(error, "error")
    
  }
};

export const latestFileUpload = async (obj) => {
    let isSuccess = false;
    let data;
    try {
        // console.log('Initiating API call...');
        // console.log('FormData:', obj);
        const res = await api.post(`/upload/excel/`, obj, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        // console.log('API response:', res);
        if (typeof res === "object" && res != null && res.status === 200) {
            if (res?.status === 200) {
                isSuccess = true;
                data =res;
                return data;
            }
        }
    } catch (err) {
        const errorMessage = err?.message;
        console.error('API call failed:', errorMessage);
        isSuccess = false;
        data= err.response;
    }
    return data;
};

// For Dashboard ------------------------------------

  export const getUserRole = async (payload) => {
    try {
      const response = await api.post('/save_sign_in',payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching first table data:', error);
    }
  };
  export const getUserFuctionDetails = async (payload) => {
    try {
      const response = await api.post('/save_function_usage',payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching first table data:', error);
    }
  };
  export const getUserActivityLogs = async (payload) => {
    try {
      const response = await api.post('/get_user_activity_logs',payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching first table data:', error);
    }
  };
  export const getOverAllReports = async (payload) => {
    try {
      const response = await api.post('/get_overall_reports',payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching first table data:', error);
    }
  };
  export const getSignOutDetails = async (payload) => {
    try {
      const response = await api.post('/save_sign_out',payload);
      return response.data;
    } catch (error) {
      console.error('Error fetching first table data:', error); 
    }
  };
